<template lang="pug">
v-container(ma-0 pa-0 fluid)
  v-layout(text-xs-center='', wrap='')
    v-flex(xs12='')
      v-carousel(hide-controls hide-delimiters style="width: 100vw;")
        v-carousel-item.studentImages(v-for='(item,i) in images', :key='i', :src='item' style="width: 100vw;")

</template>

<script>
  export default {
    data: () => ({
      images: [
        require('@/assets/photos/student1.jpg'),
        require('@/assets/photos/student4.jpg'),
        require('@/assets/photos/student5.jpg'),
        require('@/assets/photos/classroom.jpg'),
        ],
    })
  }
</script>

<style lang="scss" scoped>

</style>
